import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { TeamRanking } from '../types';

export const rankingService = {
  async getRankings(): Promise<TeamRanking[]> {
    const rankingsRef = collection(db, 'rankings');
    const q = query(rankingsRef, orderBy('rank', 'asc'));
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as TeamRanking[];
  },

  getTeamLogo: async (teamName: string): Promise<string | null> => {
    const rankingsRef = collection(db, 'rankings');
    const q = query(rankingsRef, where('club', '==', teamName));
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      return snapshot.docs[0].data().logo;
    }
    return null;
  }
}; 